<div class="formgrid grid">
    <div class="col-12 md:col-12">
        <div *ngFor="let group of groupedData; let i = index">
            <h3>{{ group.title }}</h3>
            <hr />
            <div *ngIf="registro" class="tabla-card">
                <p-table [value]="group.items" [paginator]="false" responsiveLayout="stack"
                    styleClass="p-datatable-gridlines" [tableStyle]="{ 'min-width': '50rem' }">
                    <ng-template pTemplate="body" let-item>
                        <tr class="tr-body">
                            <td id="{{item.label}}" class="td-title-table-r-profesional">{{ item.label }}</td>
                            <td>{{ item.formattedValue }}</td>
                              <div class="flex justify-content-end mt-3">
                                 <p-button pButton icon="pi pi-calendar"
                                 *ngIf="item.label==='Fecha de Vencimiento' && !this.ls.isRolCliente()"
                                    [label]="'Editar Fecha de Vencimiento'"
                                    class="p-button-text"
                                    (click)="abrirDialogoFechas()">
                                </p-button>
                            </div>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </div>
</div>
<p-dialog *ngIf="!this.ls.isRolCliente()" header="Actualizar fecha de vencimiento"
          [(visible)]="mostrarDialogo"
          [modal]="true"
          [closable]="true"
          [style]="{width: '40vw'}"
          [baseZIndex]="10000"
          (onHide)="cancelarDialogo()">

  <div class="field">
    <label for="fechaVencimiento">Fecha de vencimiento</label>
    <p-calendar
    [(ngModel)]="fechaDialog"
    [minDate]="minFecha"
    [showIcon]="true"
    [dateFormat]="'yy-mm-dd'"
    inputId="fechaVencimiento"
    [appendTo]="'body'">
    </p-calendar>
  </div>

  <div class="flex justify-content-end mt-3">
    <button pButton label="Guardar"
            [loading]="this.showLoader()"
            (click)="guardarFecha()"
            [disabled]="!fechaDialog">
    </button>
  </div>
</p-dialog>

